/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Video_Export_Segment_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_duration_label = /** @type {((inputs?: Video_Export_Segment_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("期间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração")
	return /** @type {LocalizedString} */ ("Duration")
});